import { celebrationTimeline } from "../rendering/celebration/celebrationTimeline";

// Source-file seconds. The 2:00 entrance is the listener's chosen passage.
export const firstSnowScore = {
  openingStart: 64,
  preludeStart: 64,
  preludeEnd: 112,
  boundaryFade: 0.65,
  climaxStart: 120,
} as const;

export function getClimaxPosition(celebrationElapsed: number) {
  return firstSnowScore.climaxStart + Math.max(0, celebrationElapsed - celebrationTimeline.firstBurst);
}

export function shouldRepeatPrelude(position: number) {
  return position >= firstSnowScore.preludeEnd - firstSnowScore.boundaryFade;
}
